import styled from "styled-components";
import TextField from "@/atoms/TextField";
import PropTypes from "prop-types";
import cx from "classnames";

const Trigger = styled.button`
  font-weight: 500;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
`;

const StyledTextField = styled(TextField)`
  padding-bottom: 0;
  flex-grow: 1;
`;

/**
 * @deprecated - use `@radix-ui/react-dialog`
 * @see `components/Dialog/DialogPrimitives.tsx`
 */
const TextFieldWithTrigger = ({
  triggerClassName,
  triggerLabel,
  onTriggerClick,
  className,
  responsiveClassName,
  textFieldClassName,
  ...props
}) => {
  return (
    <div className={cx("gap-x-4 items-center", responsiveClassName, className)}>
      <StyledTextField {...props} className={textFieldClassName} disabled />
      {onTriggerClick && (
        <div className={"mt-2"}>
          <Trigger
            className={cx(triggerClassName, { "pt-4": !!props.label })}
            onClick={onTriggerClick}
            type={"button"}
          >
            {triggerLabel}
          </Trigger>
        </div>
      )}
    </div>
  );
};

TextFieldWithTrigger.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helpText: PropTypes.string,
  placeholder: PropTypes.string,
  triggerClassName: PropTypes.string,
  onTriggerClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  triggerLabel: PropTypes.string.isRequired,
  responsiveClassName: PropTypes.string,
  textFieldClassName: PropTypes.string,
};

TextFieldWithTrigger.defaultProps = {
  responsiveClassName: "grid md:grid-cols-2",
};

export default TextFieldWithTrigger;
